// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider-module--divider--2xdON","fullWidth":"divider-module--fullWidth--3V3GI","thin":"divider-module--thin--1hpqB","alignLeft":"divider-module--alignLeft--3vkeF"};